
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator'
import countries from "@/data/contries.json";
import decls from "@/data/decl_countries.json"

@Options({
  props: {
    modelValue: String,
    placeholder: String,
  }
})
export default class CountryPicker extends Vue {

  value!: string;
  @Prop({default: 'Выберите страну'})
  placeholder!: string
  @Prop({})
  modelValue!:string;
  @Prop({default: false})
  decl!: boolean;

  country_filter = "";
  countries = countries;
  list_showed = false;
  filter_empty = false;

  filteredCountries(){
    let out = [];
    for(let country of this.countries){

      if(new RegExp(this.country_filter,"ui").test(country.label)){
        out.push(country)
      }
    }
    this.filter_empty = out.length === 0;
    return out;
  }

  getCountryName(){
    if(!this.list_showed && this.modelValue && this.decl && this.modelValue in decls){
      const decl = (decls as any)[this.modelValue];
      return "из " + decl;
    }
    return this.modelValue;
  }

  mounted(){
    document.addEventListener('mousedown',this.onDocumentClick);
  }
  beforeUnmount(){
    document.removeEventListener('mousedown',this.onDocumentClick);
  }

  pick_country(country: any){
    this.country_filter = country.label;
    this.list_showed = false;
    this.$emit("update:modelValue",country.label);
    this.$emit("input",country.label);
  }

  onInput(e: InputEvent){
    this.country_filter = (e.target as HTMLInputElement).value;
    this.$emit("update:modelValue",this.country_filter);
    this.$emit("input",this.country_filter);
  }

  openList(){
    this.list_showed = true;
  }

  closeList(){
    this.list_showed = false;
  }

  clearInput(){
    this.country_filter = "";
    this.$emit("update:modelValue","");
    this.$emit("input","");
  }

  onDocumentClick(e: any){
    if(!e.path.includes(this.$el)){
      this.closeList();
    }
  }
}
